export const FIREBASEREF_UPLOADS = "uploads";
export const FIREBASEREF_NEWUPLOADS = "new_uploads";

export const MAINCOLUMNS = {
    widescreen: 5,    
    largeScreen: 6,
    computer: 7,
    tablet: 10,
    mobile: 14
}

export const HOMECOLUMNS = {
    widescreen: 8,    
    largeScreen: 9,
    computer: 10,
    tablet: 15,
    mobile: 15
}

export const FILETYPE_BASICWISH = "BASICWISH";
export const FILETYPE_CHARTER = "CHARTER";
export const FILETYPE_SCENARIO = "SCENARIO";
export const FILETYPE_CURRENTSTATUS = "CURRENTSTATUS";
export const FILETYPE_FINAL = "FINAL";

export const FILETYPELABELS = {
    BASICWISH: "Basicwish",
    CHARTER: "Charter",
    SCENARIO: "Scenario"
};


// WEBPACK FOOTER //
// ./src/globals.js